module.exports = "/_next/static/images/shrink_coupon-5fa2741e868f033a00db424d9b21af6e.png";